// tslint:disable-next-line:no-console
const log = console.log;
export default { log };
